import { createSelector } from '@reduxjs/toolkit';
export const selectPortalState = state => state.portal;
export const selectPortalId = createSelector(selectPortalState, portal => portal.portalId);
export const selectAccountName = createSelector([selectPortalState], portal => portal.hubAccountNameOrDomain);